import { render, staticRenderFns } from "./groupDetail.vue?vue&type=template&id=104462e3"
import script from "./groupDetail.vue?vue&type=script&lang=js"
export * from "./groupDetail.vue?vue&type=script&lang=js"
import style0 from "./groupDetail.vue?vue&type=style&index=0&id=104462e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports